import React from 'react';
import RequireEvent from '../../components/RequireEvent';
import '../../styles/guests.css';
import { choose } from '../../utils/platform';
import { useStatus } from './useStatus';
import StatusDesktop from './Status.desktop';
import StatusMobile from './Status.mobile';

const StatusView = choose(StatusDesktop, StatusMobile);

function StatusInner({ event }) {
  const vm = useStatus(event);
  if (!vm.canView) {
    return (
      <div>
        <div className="page-head"><h1>Mark Status</h1></div>
        <div className="card card-pad empty">You don't have access to members.</div>
      </div>
    );
  }
  return <StatusView vm={vm} />;
}

export default function Status() {
  return <RequireEvent>{(event) => <StatusInner event={event} />}</RequireEvent>;
}
